import BitmapBaseValue from 'core/display/context/texts/BitmapBaseValue'
import { gsap } from 'gsap'
import { FormatService } from 'services/FormatService'
import { signal } from 'services/SignalsService'
import { time } from 'settings/custom/rolling'

export default class FreespinsTotalWinTextCurrency extends BitmapBaseValue{
  constructor(data) {
    super(data)
    this.winModel = game.models.WinModel.get()
    this.freespinModel = game.models.FreespinModel.get()
    this.tween = { value: 0 }
    this.scale.x = this.scale.y = data.scale || 1

    signal.once('INIT:FREESPINS', this.initClass.bind(this))
    signal.on('STATE:OUT:FS-START', this.initClass.bind(this))
    if (game.models.CascadeModel.get().isCascade) {
      signal.on('CASCADE-WIN-UPDATE-COUNTER', this.update.bind(this))
    }
    else{
      signal.on('WIN-COLLECT', this.update.bind(this))
    }
  }

  initClass() {
    this.tween.value = this.freespinModel.totalWin || 0
    this.onUpdate()
  }

  onUpdate() {
    super.update(FormatService.currency(this.tween.value))
  }

  update({ type, amount }) {
    let value
    if (game.models.CascadeModel.get().isCascade) {
      value = this.tween.value + amount
    }
    else {
      value = this.winModel.expendingWin
        ? this.freespinModel.totalWin - this.winModel.expendingWin
        : this.freespinModel.totalWin
    }
    const updateTween = gsap.to(this.tween, time[type], {
      value, onUpdate: () => {
        this.onUpdate()
      }, onComplete: () => {
        updateTween.kill()
      },
    })
  }
}
